(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["service-list"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function fmt(n) {
    return Math.round(n).toLocaleString('da-DK');
  }

  function uniqueRef() {
    return 'SRV' + Date.now();
  }

  function updateEstimate() {
    var checkboxes = document.querySelectorAll('.service-checkbox:checked');
    var totalArbejde = 0;

    checkboxes.forEach(function (cb) {
      var timer = parseFloat(cb.dataset.timer) || 0;
      var timepris = parseFloat(cb.dataset.timepris) || 0;
      totalArbejde += timer * timepris;
    });

    document.getElementById('est-arbejde').textContent = fmt(totalArbejde) + ' kr';
    document.getElementById('est-total').textContent = fmt(totalArbejde) + ' kr';
  }

  function initTermsScroll() {
    var termsEl = document.getElementById('service-terms-scroll');
    var acceptCb = document.getElementById('terms-accept');
    if (!termsEl || !acceptCb) return;

    function checkScroll() {
      var atBottom = termsEl.scrollTop + termsEl.clientHeight >= termsEl.scrollHeight - 8;
      if (atBottom) {
        acceptCb.disabled = false;
        acceptCb.closest('label').classList.add('is-enabled');
        termsEl.removeEventListener('scroll', checkScroll);
        termsEl.removeEventListener('keyup', checkScroll);
      }
    }

    termsEl.addEventListener('scroll', checkScroll);
    termsEl.addEventListener('keyup', checkScroll);
    checkScroll();
  }

  function initSubmitToggle() {
    var acceptCb = document.getElementById('terms-accept');
    var submitBtn = document.getElementById('service-submit-btn');
    if (!submitBtn) return;

    if (!acceptCb) {
      submitBtn.disabled = false;
      submitBtn.removeAttribute('aria-disabled');
      return;
    }

    acceptCb.addEventListener('change', function () {
      submitBtn.disabled = !acceptCb.checked;
      submitBtn.setAttribute('aria-disabled', String(!acceptCb.checked));
    });
  }

  function buildMailto(ref) {
    var adminEmail = (document.querySelector('meta[name="service-admin-email"]') || {}).content || '';
    var checkboxes = document.querySelectorAll('.service-checkbox:checked');
    var serviceLines = [];
    var totalTimer = 0, totalArbejde = 0;

    checkboxes.forEach(function (cb) {
      var timer = parseFloat(cb.dataset.timer) || 0;
      var timepris = parseFloat(cb.dataset.timepris) || 0;
      totalTimer += timer;
      totalArbejde += timer * timepris;
      serviceLines.push('- ' + cb.value + ' (' + timer + ' t @ ' + timepris + ' kr/t)');
    });

    var serviceNames = Array.from(checkboxes).map(function (cb) { return cb.value; }).join(', ');
    var navn = (document.getElementById('sf-navn') || {}).value || '';
    var telefon = (document.getElementById('sf-telefon') || {}).value || '';
    var email = (document.getElementById('sf-email') || {}).value || '';
    var cykelModel = (document.getElementById('sf-cykel-model') || {}).value || '';
    var cykelAargang = (document.getElementById('sf-cykel-aargang') || {}).value || '';
    var udstyr = (document.getElementById('sf-udstyr') || {}).value || '';
    var tidspunkt = (document.getElementById('sf-tidspunkt') || {}).value || '';

    var subject = 'Forespørgsel service: ' + serviceNames + ' — ' + cykelModel + ' ' + cykelAargang + ' — Ref:' + ref;

    var body = [
      '=== SERVICEFORESPØRGSEL ===',
      'Reference: ' + ref,
      '',
      '--- VALGTE YDELSER ---',
      serviceLines.join('\n'),
      '',
      'Samlet estimeret arbejdstid: ' + totalTimer + ' t',
      'Estimeret arbejdspris: ' + fmt(totalArbejde) + ' kr',
      '',
      'NB: Pris på komponenter og materialer aftales individuelt efter vurdering.',
      '',
      '--- KUNDEOPLYSNINGER ---',
      'Navn: ' + navn,
      'Telefon: ' + telefon,
      'E-mail: ' + email,
      '',
      '--- CYKEL ---',
      'Model: ' + cykelModel,
      'Årgang: ' + cykelAargang,
      'Udstyr / noter: ' + (udstyr || '–'),
      '',
      '--- ØNSKET TIDSPUNKT ---',
      tidspunkt || '–',
      '',
      '---',
      'Vi svarer inden for 24 timer på hverdage.',
    ].join('\n');

    return 'mailto:' + encodeURIComponent(adminEmail)
      + '?subject=' + encodeURIComponent(subject)
      + '&body=' + encodeURIComponent(body);
  }

  function initForm() {
    var form = document.getElementById('service-form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var checkboxes = document.querySelectorAll('.service-checkbox:checked');
      if (checkboxes.length === 0) {
        alert('Vælg mindst én serviceydelse.');
        return;
      }
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }
      var ref = uniqueRef();
      window.location.href = buildMailto(ref);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.service-checkbox').forEach(function (cb) {
      cb.addEventListener('change', updateEstimate);
    });
    initTermsScroll();
    initSubmitToggle();
    initForm();
    updateEstimate();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
